import * as React from 'react'
import { dateFormat } from '../../../utils/date'
import { currencyFormat, formatNumber } from '../../../utils/number'
import { Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow } from '@mui/material'
import GenericTablePaginationActions from '../../../component/generic/GenericTablePaginationActions'

const columns = [
    { id: 'idUnidade', label: 'ID Unidade', minWidth: 80, align: 'left' },
    { id: 'idPedidoIntegracao', label: 'ID Pedido', minWidth: 80, align: 'center' },
    { id: 'tipoPedido', label: 'Tipo Pedido', minWidth: 100, align: 'center' },
    { id: 'tipoImportacaoDescricao', label: 'Origem', minWidth: 100, align: 'center' },
    { id: 'dataPedido', label: 'Data', minWidth: 50, align: 'center' },
    { id: 'dataCancelamento', label: 'Cancelamento', minWidth: 50, align: 'center' },
    { id: 'quantidadePessoas', label: 'Qtd. Pessoas', minWidth: 80, align: 'center' },
    { id: 'valorTotal', label: 'Valor total', minWidth: 100, align: 'right' },
]

export default function ListRealTime({ data }) {
    const [page, setPage] = React.useState(0)
    const [rowsPerPage, setRowsPerPage] = React.useState(10)
    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - data?.length) : 0

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10))
        setPage(0)
    }

    return (
        <TableContainer elevation={0} component={Paper}>
            <Table stickyHeader>
                <TableHead>
                    <TableRow>
                        {columns.map((column) => (
                            <TableCell
                                key={column.id}
                                align={column.align}
                                style={{ minWidth: column.minWidth, fontSize: '14px' }}
                            >
                                {column.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>

                <TableBody>
                    {(rowsPerPage > 0 ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : data).map((row, index) => (
                        <TableRow key={index}>
                            <TableCell align='left'>
                                {row.idUnidade}
                            </TableCell>
                            <TableCell align="center">
                                {row.idPedidoIntegracao}
                            </TableCell>
                            <TableCell align="center">
                                {row.tipoPedido}
                            </TableCell>
                            <TableCell align="center">
                                {row.tipoImportacaoDescricao}
                            </TableCell>
                            <TableCell align="center">
                                {dateFormat(row.dataPedido, { pattern: 'dd/MM/yyyy' })}
                            </TableCell>
                            <TableCell align="center">
                                {dateFormat(row.dataCancelamento, { pattern: 'dd/MM/yyyy' })}
                            </TableCell>
                            <TableCell align="center">
                                {formatNumber(row.quantidadePessoas, { style: 'decimal', minimumFractionDigits: '0' })}
                            </TableCell>

                            <TableCell align="right">
                                {currencyFormat(row.valorTotal, { simbol: 'R$' })}
                            </TableCell>
                        </TableRow>
                    ))}

                    {emptyRows > 0 && (
                        <TableRow style={{ height: 53 * emptyRows }}>
                            <TableCell colSpan={8} />
                        </TableRow>
                    )}
                </TableBody>

                <TableFooter>
                    <TableRow>
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 50, { label: 'Todos', value: -1 }]}
                            colSpan={8}
                            count={data?.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            labelRowsPerPage='linhas por página'
                            slotProps={{
                                select: {
                                    inputProps: {
                                        'aria-label': 'linhas por página',
                                    },
                                },
                                native: true,
                            }}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            ActionsComponent={GenericTablePaginationActions}
                        />
                    </TableRow>
                </TableFooter>
            </Table>
        </TableContainer>
    )
}